import OverlayTrigger from "react-bootstrap/OverlayTrigger";

export const OverlayTooltip = ({
  data,
  children,
  placement = "auto",
  trigger = ["hover", "focus"],
  component,
}: any) => (
  <OverlayTrigger trigger={trigger} placement={placement} overlay={component(data)}>
    <div className="text-secondary" style={{cursor: 'default'}}>{children}</div>
  </OverlayTrigger>
);
